// extracted by mini-css-extract-plugin
export default {"container":"play-pause_container__3qepL","icon":"play-pause_icon__242Kj"};